export const submitEmail = `

<p>Many advisors now use portfolio risk software, but do they really understand portfolio risk management? </p> 

<p>Congratulations on being proactive and signing up for this unique course. We look forward to teaching you about portfolio risk management to help you become the best advisor to your clients that you can be.</p>

<p>Respectfully yours,</p>

<p>Yon Perullo, CFA</p>

<p>CEO, RiXtrema inc</p>

<p>10 DAYS TO PORTFOLIO RISK MASTERY: FREE CHALLENGE:</p>

<p>May 10 at Noon/12 PM EST: Session 1: Foundations of Risk - Part 1.</p>

<p>May 12 at Noon/12 PM EST: Session 2: Foundations of Risk - Part 2.</p>

<p>May 17 at Noon/12 PM EST: Session 3: Equity Risk Management - Part 1: Basics.</p>

<p>May 19 at Noon/12 PM EST: Session 4: Equity Risk Management - Part 2: Portfolios.</p>

<p>May 24 at Noon/12 PM EST: Session 5: Fixed Income Risk Management - Part 1: Risk Factors.</p>

<p>May 26 at Noon/12 PM EST: Session 6: Fixed Income Risk Management - Part 2: Curves.</p>

<p>May 31 at Noon/12 PM EST: Session 7: Behavioral and Historical Aspects of Risk.</p>

<p>June 2 at Noon/12 PM EST: Session 8: Analyzing Portfolio Risks.</p>

<p>June 7 at Noon/12 PM EST: Session 9: Advanced Topics: Cryptocurrency, Structured Notes, options, etc.</p>

<p>June 9 at Noon/12 PM EST: Session 10: Winning Clients with Risk Management.</p>`

export const firstInvite = `
Hi there,

You are invited to a Zoom webinar.
When: May 10, 2022 12:00 PM Eastern Time (US and Canada)
Topic: 10 Days to Risk Mastery Session 1: Foundations of Risk - Part 1

Please click the link below to join the webinar:
https://us06web.zoom.us/j/82473608401
Or One tap mobile : 

US: +16699006833,,82473608401#  or +12532158782,,82473608401# 

Or Telephone:

Dial(for higher quality, dial a number based on your current location):

US: +1 669 900 6833  or +1 253 215 8782  or +1 301 715 8592  or +1 312 626 6799  or +1 346 248 7799  or +1 646 876 9923 

Webinar ID: 824 7360 8401
International numbers available: https://us06web.zoom.us/u/kcucy2shds
`

export const secondInvite = `
Hi there,

You are invited to a Zoom webinar.
When: May 12, 2022 12:00 PM Eastern Time (US and Canada)
Topic: 10 Days to Risk Mastery Session 2: Foundations of Risk - Part 2

Please click the link below to join the webinar:
https://us06web.zoom.us/j/82160362236

Or One tap mobile : 

US: +12532158782,,82160362236#  or +13017158592,,82160362236# 

Or Telephone:
Dial(for higher quality, dial a number based on your current location):

US: +1 253 215 8782  or +1 301 715 8592  or +1 312 626 6799  or +1 346 248 7799  or +1 646 876 9923  or +1 669 900 6833 

Webinar ID: 821 6036 2236
International numbers available: https://us06web.zoom.us/u/kefCNsEpsk

`

export const thirdInvite = `
Hi there,

You are invited to a Zoom webinar.
When: May 17, 2022 12:00 PM Eastern Time (US and Canada)
Topic: 10 Days to Risk Mastery Session 3: Equity Risk Management - Part 1: Basics

Please click the link below to join the webinar:
https://us06web.zoom.us/j/89417260300

Or One tap mobile : 
US: +13126266799,,89417260300#  or +13462487799,,89417260300#

Or Telephone:

Dial(for higher quality, dial a number based on your current location):
US: +1 312 626 6799  or +1 346 248 7799  or +1 646 876 9923  or +1 669 900 6833  or +1 253 215 8782  or +1 301 715 8592 

Webinar ID: 894 1726 0300

International numbers available: https://us06web.zoom.us/u/kbgzfTif9s
`
export const fourthInvite = `
Hi there,

You are invited to a Zoom webinar.
When: May 19, 2022 12:00 PM Eastern Time (US and Canada)
Topic: 10 Days to Risk Mastery Session 4: Equity Risk Management - Part 2: Portfolios

Please click the link below to join the webinar:
https://us06web.zoom.us/j/82541078535

Or One tap mobile : 
    
US: +13462487799,,82541078535#  or +16468769923,,82541078535# 
Or Telephone:
    
Dial(for higher quality, dial a number based on your current location):
US: +1 346 248 7799  or +1 646 876 9923  or +1 669 900 6833  or +1 253 215 8782  or +1 301 715 8592  or +1 312 626 6799 
Webinar ID: 825 4107 8535
International numbers available: https://us06web.zoom.us/u/kb03RHZRih


`
export const fifthInvite = `
Hi there,

You are invited to a Zoom webinar.
When: May 24, 2022 12:00 PM Eastern Time (US and Canada)
Topic: 10 Days to Risk Mastery Session 5:  Fixed Income Risk Management - Part 1: Risk Factors

Please click the link below to join the webinar:
https://us06web.zoom.us/j/88521266337
Or One tap mobile : 

US: +13462487799,,88521266337#  or +16468769923,,88521266337# 
Or Telephone:

Dial(for higher quality, dial a number based on your current location):
US: +1 346 248 7799  or +1 646 876 9923  or +1 669 900 6833  or +1 253 215 8782  or +1 301 715 8592  or +1 312 626 6799 
Webinar ID: 885 2126 6337

International numbers available: https://us06web.zoom.us/u/kopJ34L9m


`

export const sixthInvite = `
Hi there,

You are invited to a Zoom webinar.
When: May 26, 2022 12:00 PM Eastern Time (US and Canada)
Topic: 10 Days to Risk Mastery Session 6: Fixed Income Risk Management - Part 2: Curves

Please click the link below to join the webinar:
https://us06web.zoom.us/j/85150654058
Or One tap mobile : 

US: +16468769923,,85150654058#  or +16699006833,,85150654058# 
Or Telephone:

Dial(for higher quality, dial a number based on your current location):
US: +1 646 876 9923  or +1 669 900 6833  or +1 253 215 8782  or +1 301 715 8592  or +1 312 626 6799  or +1 346 248 7799 
Webinar ID: 851 5065 4058

International numbers available: https://us06web.zoom.us/u/kcxanHJcQu
`

export const seventhInvite = `
Hi there,

You are invited to a Zoom webinar.
When: May 31, 2022 12:00 PM Eastern Time (US and Canada)
Topic: 10 Days to Risk Mastery Session 7: Behavioral and Historical Aspects of Risk

Please click the link below to join the webinar:
https://us06web.zoom.us/j/86306358894

Or One tap mobile : 
US: +12532158782,,86306358894#  or +13017158592,,86306358894# 

Or Telephone:

Dial(for higher quality, dial a number based on your current location):
US: +1 253 215 8782  or +1 301 715 8592  or +1 312 626 6799  or +1 346 248 7799  or +1 646 876 9923  or +1 669 900 6833 
Webinar ID: 863 0635 8894

International numbers available: https://us06web.zoom.us/u/keEB43rDsO


`

export const eighthInvite = `
Hi there,

You are invited to a Zoom webinar.
When: Jun 2, 2022 12:00 PM Eastern Time (US and Canada)
Topic: 10 Days to Risk Mastery Session 8: Analyzing Portfolio Risks

Please click the link below to join the webinar:
https://us06web.zoom.us/j/81781982828
Or One tap mobile : 

US: +16468769923,,81781982828#  or +16699006833,,81781982828# 

Or Telephone:

Dial(for higher quality, dial a number based on your current location):
US: +1 646 876 9923  or +1 669 900 6833  or +1 253 215 8782  or +1 301 715 8592  or +1 312 626 6799  or +1 346 248 7799 

Webinar ID: 817 8198 2828
International numbers available: https://us06web.zoom.us/u/kcb4KFHWjU
`

export const ninthInvite = `
Hi there,

You are invited to a Zoom webinar.
When: Jun 7, 2022 12:00 PM Eastern Time (US and Canada)
Topic: 10 Days to Risk Mastery Session 9: Advanced Topics: Cryptocurrency, Structured Notes, options, etc.

Please click the link below to join the webinar:
https://us06web.zoom.us/j/88202872937
Or One tap mobile : 
US: +13017158592,,88202872937#  or +13126266799,,88202872937# 
Or Telephone:
Dial(for higher quality, dial a number based on your current location):
US: +1 301 715 8592  or +1 312 626 6799  or +1 346 248 7799  or +1 646 876 9923  or +1 669 900 6833  or +1 253 215 8782 
Webinar ID: 882 0287 2937
International numbers available: https://us06web.zoom.us/u/kb60DnLHw


`

export const tenthInvite = `
Hi there,

You are invited to a Zoom webinar.
When: Jun 9, 2022 12:00 PM Eastern Time (US and Canada)
Topic: 10 Days to Risk Mastery Session 10: Winning Clients with Risk Management

Please click the link below to join the webinar:
https://us06web.zoom.us/j/89345994785

Or One tap mobile : 
US: +13017158592,,89345994785#  or +13126266799,,89345994785# 

Or Telephone:
Dial(for higher quality, dial a number based on your current location):
US: +1 301 715 8592  or +1 312 626 6799  or +1 346 248 7799  or +1 646 876 9923  or +1 669 900 6833  or +1 253 215 8782 
Webinar ID: 893 4599 4785
International numbers available: https://us06web.zoom.us/u/kb34oa94lN
`
